import { useEffect, useState, Fragment } from "react";
import { imvs_url } from "../../../services/host_data";
import axios from "axios";
import { useQuery } from "react-query";
import LoadingWheel from "../../assets/LoadingWheel";
import { SpecIcon } from "../../assets/_ImvCardAssets";
import { BedroomIcon, BathroomIcon } from "../../assets/ImvIcons";
import { MoedaFormatada } from "../../assets/_ImvCardAssets";
import { ImvEditModal } from "./_ImvEdit";
import { ImvThumb } from "../../Home/_imvImagesCarousel";


export default function Imvs() {
  const [imvs, setImvs] = useState([]);
  //* Modal de Edição
  const [isOpen, setIsOpen] = useState(false)
  const [selectedImv, setSelectedImv] = useState()

  const [filteredData, setFielteredData] = useState({})

  const [imageUrls, setImageUrls] = useState([])

  const fetchImoveis = async () => {
    const response = await Promise.resolve(axios.get(imvs_url, {
      headers: {
        'api-key': 'xUp2jAz5hQZM#wCsKb',
        'Content-Type': 'application/json'
      },
    }))

    return response.data
  }

  const { data, isLoading } = useQuery('imoveis', fetchImoveis)

  useEffect(() => {
    console.log('Imovel enviado para o modal: ', selectedImv)
  }, [selectedImv])

  const onOpen = (imv) => {
    setSelectedImv(imv)
    setIsOpen(true)
  }

  const onClose = () => {
    setIsOpen(false)
  }

  return (<>
    {/* Modal de Edição */}
    <ImvEditModal imv={selectedImv} isOpen={isOpen} onClose={onClose} /> 

    <section className="text-white">
      <h1 className="text-center text-6xl font-thin my-4"> Imoveis Cadastrados </h1>

      <nav className="w-full h-20 p-5 flex gap-x-5 items-center justify-center">
        <input type="text" className="w-80 h-full rounded-lg text-black px-2" placeholder='Endereço, Nº Registro, Bairro...' />
        <button className="bg-[#1d4aa7] h-full rounded-md px-5">Pesquisar</button>
      </nav>

      {data && (
        <section className="w-4/5 mx-auto grid grid-cols-4 justify-evenly gap-10 border border-sky-900 p-10 max-[1770px]:grid-cols-3 max-[1300px]:grid-cols-1 rounded-lg">
          {isLoading && (
            <LoadingWheel />
          )}
          {data.map((imv, imvIndex) => (
            <article key={imvIndex} onClick={() => onOpen(imv)}
              className='bg-gradient-to-br from-[#3d2269] to-[#112c63cc] transition-[5s] hover:cursor-pointer hover:bg-[#1d4aa7] rounded-xl'
            >

              <header className="w-full aspect-video max-[500px]:aspect-square bg-[#ffffff13] rounded-xl">
                <ImvThumb nreg={imv.nreg} />
              </header>
              <main className="md:p-0 md:pt-2 h-auto m-0 max-md:p-3 max-md:text-xs">
                <article className="flex flex-col gap-y-3 justify-evenly md:font-[20pt] items-stretch max-md:gap-y-3 px-5 max-[420px]:px-1 py-2">
                  <p className="text-[15pt] text-[#fff] max-sm:text-[5pt]"> Nº: {imv.nreg} </p>
                  {/* <p className="text-[8pt] text-white ">Data de Registro: {Date.parse(imv.reg_data)} </p> */}

                  <div className="md:pt-0">
                    <h1 className="capitalize text-xl"> {imv.end} </h1>
                    <h1 className="capitalize text-xs"> {imv.bairro} </h1>
                  </div>

                  <section className="w-full self-end gap-4">
                    <div className="grid grid-flow-row md: justify-between">
                      {/* Especificações Basicas */}
                      <span className="grid grid-flow-col items-center">
                        <SpecIcon icon={<BedroomIcon />} />
                        <h1> {imv.quartos} {imv.quartos > 1 ? 'Quartos' : 'Quarto'} </h1>
                      </span>
                      <span className="grid grid-flow-col items-center">
                        <SpecIcon icon={<BathroomIcon />} />
                        <h1> {imv.banheiros} {imv.banheiros > 1 ? 'Banheiros' : 'Banheiro'} </h1>
                      </span>
                    </div>
                  </section>

                  <footer className="">
                    <section className="w-full flex justify-between max-md:justify-start">
                      {imv.is_active ? (
                        <h2 className=" rounded-full p-1 px-3 from-[#4936b6] via-[#7140cad3] to-[#503eb820] bg-gradient-to-br animate-pulse"> Imóvel Ativo </h2>
                      ) :
                        (
                          <h2 className="text-[#fff8]"> Imóvel Inativo </h2>
                        )
                      }
                      <h2 className=""> <MoedaFormatada valor={imv.preco} /> </h2>
                    </section>
                  </footer>
                </article>
              </main>
            </article>
          ))}
        </section>
      )}
    </section>
  </>);
}
